import { InitialFilterState } from './filters.data'
import {
  FilterNames,
  Filters,
  FiltersContextState,
  ReservationMoveInRange,
  ReservationMoveOutRange,
} from './filters.type'

export const FilterActionTypes: { [key: string]: string } = {
  clearFilters: 'FilterAction_clearFilters',
  setMarketSegments: 'FilterAction_setMarketSegments',
  setFilters: 'FilterAction_setFilters',
  setSearchString: 'FilterAction_setSearchString',
  setReservationMoveOutRange: 'FilterAction_setReservationMoveOutRange',
  clearReservationMoveOutRange: 'FilterAction_clearReservationMoveOutRange',
  setReservationMoveInRange: 'FilterAction_setReservationMoveInRange',
  clearReservationMoveInRange: 'FilterAction_clearReservationMoveInRange',
  setReservationMinLengthOfStay: 'FilterAction_setReservationMinLengthOfStay',
}

export type ActionReturnType = {
  payload: Partial<FiltersContextState>
  type: string
}

export const FilterActions = {
  clearFilters: ({ filterName }: { filterName: FilterNames }): ActionReturnType => {
    const filterKey: keyof Omit<FiltersContextState, 'marketSegmentFilters' | 'searchString'> = `${filterName}Filters`
    return {
      type: FilterActionTypes.clearFilters,
      payload: {
        [filterKey]: InitialFilterState[filterKey],
      },
    }
  },
  setSearchString: ({ val = '' }: { val: string }): ActionReturnType => {
    return {
      type: FilterActionTypes.setSearchString,
      payload: {
        searchString: val.length > 0 ? val : null,
      },
    }
  },
  setMarketSegments: ({
    fieldOperationsHubs,
    fieldOperationsRegions,
    ids,
    marketSegmentTypes,
  }: {
    fieldOperationsHubs: string[]
    fieldOperationsRegions: string[]
    ids: number[]
    marketSegmentTypes: string[]
  }): ActionReturnType => {
    return {
      type: FilterActionTypes.setMarketSegments,
      payload: {
        marketSegmentFilter: {
          fieldOperationsHubs: [...fieldOperationsHubs],
          fieldOperationsRegions: [...fieldOperationsRegions],
          marketSegmentIds: [...ids],
          marketSegmentTypes: [...marketSegmentTypes],
        },
      },
    }
  },
  setFilters: ({ filterName, filters }: { filterName: FilterNames; filters: Filters }): ActionReturnType => {
    const filterKey: keyof Omit<FiltersContextState, 'marketSegmentFilters' | 'searchString'> = `${filterName}Filters`
    return {
      type: FilterActionTypes.setFilters,
      payload: {
        [filterKey]: filters,
      },
    }
  },
  setReservationMoveInRange: ({ r }: { r: Partial<ReservationMoveInRange> }): ActionReturnType => {
    return {
      type: FilterActionTypes.setReservationMoveInRange,
      payload: {
        reservationMoveInRange: {
          ...r,
        },
      },
    }
  },
  clearReservationMoveInRange: (): ActionReturnType => {
    return {
      type: FilterActionTypes.clearReservationMoveInRange,
      payload: {
        reservationMoveInRange: {
          moveInDate: undefined,
          moveInMax: undefined,
        },
      },
    }
  },
  setReservationMoveOutRange: ({ r }: { r: Partial<ReservationMoveOutRange> }): ActionReturnType => {
    return {
      type: FilterActionTypes.setReservationMoveOutRange,
      payload: {
        reservationMoveOutRange: {
          ...r,
        },
      },
    }
  },
  clearReservationMoveOutRange: (): ActionReturnType => {
    return {
      type: FilterActionTypes.clearReservationMoveOutRange,
      payload: {
        reservationMoveOutRange: {
          moveOutDate: undefined,
          moveOutMax: undefined,
        },
      },
    }
  },
  setReservationMinLengthOfStay: ({ val }: { val?: number }): ActionReturnType => {
    return {
      type: FilterActionTypes.setReservationMinLengthOfStay,
      payload: {
        reservationMinLengthOfStay: val,
      },
    }
  },
}
